module.exports = __webpack_public_path__ + "img/partner_img8.e90e1ea5.png";